import React from 'react'
import PropTypes from 'prop-types'
import { Body10 } from 'components/Typography'
import { Spacing50 } from 'styles/sharedStyle'
import {
  ArticleQuoteAuthor,
  ArticleQuoteCopy,
  ArticleQuoteIco,
  ArticleQuoteInner,
  ArticleQuoteWrapper,
} from './Article.style'

const ArticleQuote = ({ authorName, authorTitle, copy }) => (
  <ArticleQuoteWrapper>
    <Spacing50 />
    <ArticleQuoteInner>
      <ArticleQuoteIco viewBox="0 0 45 30" role="presentation" aria-hidden>
        <path d="m21 10.4c-.3-6.9-5.9-11.1-12.6-10.3-5.6.7-9.2 6.5-8.3 11.3 1.2 6.1 6.5 9.5 12.4 8.2.7-.2 1.5-.9 2.1-.1.5.7.2 1.6-.1 2.4-.2.5-.4.9-.6 1.4-1 2.1-2.6 3.8-4.1 5.5-.2.3-.7.9-.7.9s.8-.5 1.1-.6c7.7-3.9 11.1-10.4 10.8-18.7z" />
        <path d="m45 10.4c-.3-6.9-5.9-11.1-12.6-10.3-5.6.7-9.2 6.5-8.2 11.3 1.2 6.1 6.5 9.5 12.4 8.2.7-.2 1.5-.9 2.1-.1.5.7.2 1.6-.1 2.4-.2.5-.4.9-.6 1.4-1 2.1-2.6 3.8-4.1 5.5l-.7.9s1.1-.5 1.1-.5c7.5-4 11-10.5 10.7-18.8z" />
      </ArticleQuoteIco>
      <ArticleQuoteCopy>{copy}</ArticleQuoteCopy>
      {(!!authorName || !!authorTitle) && (
        <ArticleQuoteAuthor>
          {!!authorName && <Body10>{authorName}</Body10>}
          {!!authorTitle && <Body10>{authorTitle}</Body10>}
        </ArticleQuoteAuthor>
      )}
    </ArticleQuoteInner>
    <Spacing50 />
  </ArticleQuoteWrapper>
)

ArticleQuote.propTypes = {
  authorName: PropTypes.string,
  authorTitle: PropTypes.string,
  copy: PropTypes.string,
}

ArticleQuote.defaultProps = {
  authorName: '',
  authorTitle: '',
  copy: '',
}

export default ArticleQuote
